import React from 'react';
import { ChevronLeft, Leaf } from '../icons';

export const Header = ({ title, onBack, rightContent }) => (
    <div className="flex items-center justify-between p-4 bg-white shadow-md sticky top-0 z-10 mb-5">

        {/* Left */}
        <button
            onClick={onBack}
            className="text-[#01a499] hover:text-[#017a72] transition duration-150"
        >
            {onBack ? <ChevronLeft /> : <Leaf className="w-8 h-8 text-[#01a499]" />}
        </button>

        {/* Center */}
        <h1 className="text-xl font-bold text-gray-800">{title}</h1>

        {/* Right */}
        <div className="min-w-[140px] flex justify-end">
            {rightContent}
        </div>
    </div>
);
